import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { ChartContainer } from "@mui/x-charts/ChartContainer";
import { ResponsiveChartContainer } from "@mui/x-charts/ResponsiveChartContainer";
import { BarPlot } from "@mui/x-charts/BarChart";
import {
  LinePlot,
  MarkPlot,
  lineElementClasses,
  markElementClasses,
} from "@mui/x-charts/LineChart";
import { useState } from "react";
import Box from "@mui/material/Box";
import { ChartsXAxis } from "@mui/x-charts/ChartsXAxis";
import { ChartsYAxis } from "@mui/x-charts/ChartsYAxis";
import { CustomItemTooltipPercentage } from "../../../../../../ResuableChartTooltip/CustomItemTooltipPercentage";
import { useSelector } from "react-redux";

interface TrendDialogueProps {
  openAdsMobile: boolean;
  onCloseAdsMobile: () => void;
  GraphAdsMobile: any;
  GraphMobileTarget: any;
  GraphAchievementMobile: any;
  GraphAdsMobilePageSpecific: any;
  GraphAchievementMobilePageSpecific: any;
  GraphMobileTargetPageSpecific: any;
}

export const AdsMobileTrendDialog = ({
  openAdsMobile,
  onCloseAdsMobile,
  GraphAdsMobile,
  GraphAchievementMobile,
  GraphMobileTarget,
  GraphAdsMobilePageSpecific,
  GraphAchievementMobilePageSpecific,
  GraphMobileTargetPageSpecific,
}: TrendDialogueProps) => {
  const { selectedPage } = useSelector(
    (state: any) => state.pageSpeedPerformance
  );
  const [isResponsive] = useState(false);
  const Container = isResponsive ? ResponsiveChartContainer : ChartContainer;

  const xValues = GraphAdsMobile.map((data: any) => {
    const date = data.x;
    return date;
  }).filter(Boolean);

  const GraphAdsMobileData = selectedPage
    ? GraphAdsMobilePageSpecific.map((data: any) => data.y / 10)
    : GraphAdsMobile.map((data: any) => data.y / 10);
  const GraphAchievementMobileData = selectedPage
    ? GraphAchievementMobilePageSpecific.map((data: any) => data.y)
    : GraphAchievementMobile.map((data: any) => data.y);
  const GraphMobileTargetData = selectedPage
    ? GraphMobileTargetPageSpecific.map((data: any) => data.y / 10)
    : GraphMobileTarget.map((data: any) => data.y / 10);

  return (
    <>
      <Dialog
        open={openAdsMobile}
        onClose={onCloseAdsMobile}
        fullWidth
        maxWidth="lg"
      >
        <Box>
          <DialogTitle id="alert-dialog-title">
            {"Ads Mobile Page Speed Score"}
          </DialogTitle>
          <DialogContent>
            <Box>
              <Container
                series={[
                  { type: "bar", data: GraphAdsMobileData, color: "#6200EE" },
                  {
                    type: "line",
                    data: GraphAchievementMobileData,
                    color: "#EE6002",
                  },
                  {
                    type: "line",
                    data: GraphMobileTargetData,
                    color: "#4CAF50",
                  },
                ]}
                xAxis={[
                  {
                    data: xValues,
                    scaleType: "band",
                    id: "x-axis-id",
                    label: "",
                  },
                ]}
                width={1120}
                height={400}
              >
                <BarPlot />
                <LinePlot
                  sx={{
                    [`.${lineElementClasses.root}, .${markElementClasses.root}`]:
                      {
                        strokeWidth: 1,
                      },
                    ".MuiLineElement-series-pvId": {
                      strokeDasharray: "5 5",
                    },
                    ".MuiLineElement-series-uvId": {
                      strokeDasharray: "3 4 5 2",
                    },
                    [`.${markElementClasses.root}:not(.${markElementClasses.highlighted})`]:
                      {
                        fill: "#fff",
                      },
                    [`& .${markElementClasses.highlighted}`]: {
                      stroke: "none",
                    },
                  }}
                />
                <MarkPlot />
                <ChartsXAxis position="bottom" axisId="x-axis-id" />
                <ChartsYAxis position="right" />
                <CustomItemTooltipPercentage />
              </Container>
            </Box>
            <Grid
              container
              spacing={0}
              direction="row"
              mb={2}
              pt={2}
              className="ratedTableWrap"
              sx={{ pl: 6 }} // Use sx prop for padding-left
            >
              <Grid item xs={4}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    sx={{
                      width: 12,
                      height: 3,
                      backgroundColor: "#EE6002",
                      mr: 1,
                    }}
                  ></Box>
                  <Typography sx={{ color: "#00000099", fontSize: "12px" }}>
                    Daily Ads Mobile Score (Target Achievement)
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    sx={{
                      width: 12,
                      height: 3,
                      backgroundColor: "#4CAF50",
                      mr: 1,
                    }}
                  ></Box>
                  <Typography sx={{ color: "#00000099", fontSize: "12px" }}>
                    Quarterly Goal
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    sx={{
                      width: 12,
                      height: 3,
                      backgroundColor: "#6200EE",
                      mr: 1,
                    }}
                  ></Box>
                  <Typography sx={{ color: "#00000099", fontSize: "12px" }}>
                    Daily Average Ads Mobile Score
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ mx: "1rem", mb: "1rem" }}>
            <Button
              onClick={onCloseAdsMobile}
              size="small"
              variant="contained"
              color="secondary"
            >
              Close
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};
